// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { FeedbackRowOut } from './feedbackRowOut.zod.ts';

export const FeedbackListOut = zod.object({
  "counts": zod.record(zod.string(), zod.int()),
  "items": zod.array(FeedbackRowOut),
  "page": zod.int(),
  "page_size": zod.int(),
  "total": zod.int()
});

export type FeedbackListOut = zod.input<typeof FeedbackListOut>;
export type FeedbackListOutOutput = zod.output<typeof FeedbackListOut>;
